import { createApi } from "@reduxjs/toolkit/query/react";
import { heimdallApiUrl } from "../../../env";
import { makeBaseQueryWithUnauthentication } from "../../redux/api/baseQuery";

const TAGS = [
	"HeimdallPermission",
	"HeimdallRole",
	"HeimdallGrant",
	"HeimdallGroup",
	"HeimdallGroupGrant",
	"HeimdallEntity",
] as const;

export const emptyHeimdallApi = createApi({
	reducerPath: "heimdallApi",
	baseQuery: makeBaseQueryWithUnauthentication({
		baseUrl: heimdallApiUrl,
	}),
	tagTypes: TAGS,
	endpoints: () => ({}),
});
